// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"944fa4e2","35":"04f1e7ae","444":"4766a29f","550":"f971f9f6","784":"944fa4e2","857":"9c9bb8e7"}[chunkId] + ".chunk.css";
};